import { SET_CLIENT_NEWS } from "../actions/action-types.js";

export default function clientNews(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_NEWS:
            return (state = payload)
        default:
            return state
    }
}